/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  updateStatus({ assistantId, status }) {
    return axios.patch(`${this.url}/${assistantId}/status`, { status });
  }

  getTestConversations({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/test_conversations`);
  }

  addTestConversation({ assistantId, conversationId }) {
    return axios.post(`${this.url}/${assistantId}/test_conversations`, {
      conversation_id: conversationId,
    });
  }

  removeTestConversation({ assistantId, conversationId }) {
    return axios.delete(
      `${this.url}/${assistantId}/test_conversations/${conversationId}`
    );
  }

  getMetrics({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/metrics`);
  }

  pauseAll() {
    return axios.post(`${this.url}/pause_all`);
  }

  resumeAll() {
    return axios.post(`${this.url}/resume_all`);
  }

  getContactMemory({ contactId }) {
    return axios.get(`${this.url}/contact_memory`, {
      params: { contact_id: contactId },
    });
  }
}

export default new CaptainAssistant();
